export interface Transactions {
  id: number;
  created_by: number;
  created_at: string;
  created_by_details: {
    email: string;
    name: string;
    created_at: string;
    external_id: string | null;
  };
  status: string;
}

export interface Country {
  description: string;
  value: string;
}

export const transactionAction = {
  SCHEDULING: 'Scheduling',
  RESCHEDULING: 'Rescheduling',
  CANCELLATION: 'Cancellation',
  CHARGEBACK: 'Chargeback',
};

export const transactionActionList = [
  { label: transactionAction.CANCELLATION, value: transactionAction.CANCELLATION },
  { label: transactionAction.RESCHEDULING, value: transactionAction.RESCHEDULING },
  { label: transactionAction.SCHEDULING, value: transactionAction.SCHEDULING },
  { label: transactionAction.CHARGEBACK, value: transactionAction.CHARGEBACK },
];

export enum Status {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  PENDING = 'PENDING',
  REFUND_COMPLETED = 'REFUND_COMPLETED',
  REFUND_FAILED = 'REFUND_FAILED',
  REFUND_INITIATED = 'REFUND_INITIATED',
  REFUND_PENDING = 'REFUND_PENDING',
}

export const statusListMap: Record<Status, string> = {
  [Status.COMPLETED]: 'Completed',
  [Status.FAILED]: 'Failed',
  [Status.INITIATED]: 'Initiated',
  [Status.PENDING]: 'Pending',
  [Status.REFUND_COMPLETED]: 'Refund completed',
  [Status.REFUND_FAILED]: 'Refund failed',
  [Status.REFUND_INITIATED]: 'Refund initiated',
  [Status.REFUND_PENDING]: 'Refund pending',
};

export const statusList = Object.entries(statusListMap).map(([value, label]) => ({
  label,
  value: value as Status,
}));
